import React from 'react';

const TeamCard = ({ team }) => {
  return (
    <div className="organizer-card event-organizer">
      <div className="organizer-card-content">
        <div className="organizer-avatar">{team.avatar}</div>
        <h3>{team.name}</h3>
        <div className="role-container">
          {team.role && <p className="role">{team.role}</p>}
        </div>
        <div className="fun-title-container"></div>
        <div className="organization-container">
          <p className="organization">{team.organization}</p>
        </div>
        <p className="bio">{team.bio}</p>
      </div>
    </div>
  );
};

export default TeamCard;